import paymentReminderService from '@/views/PaymentReminder/PaymentReminderServices';
import {
  APPLY_FILTERS,
  SET_ITEMS,
  SET_TARGETING_CLIENT,
  SET_CLIENTS_DUE_CONTRACTS,
  SET_SUMMARY_INFO,
  SET_CURRENT_COMPONENT,
  SET_LATE_DAYS
} from './types';

export default {
  applyFilter({ commit }, filters) {
    commit(APPLY_FILTERS, filters);
  },

  async getPaymentReminder({ commit, state }, showLoader = true) {
    const { items, total, loanBalance } = await paymentReminderService.getPastDueClients(state.filters, showLoader);

    commit(SET_ITEMS, { items, total, loanBalance });
  },

  targetClient({ commit }, client) {
    commit(SET_TARGETING_CLIENT, client);
  },

  async getClientsDueContracts({ commit, state }, clientId) {
    const id = clientId || state.targetingClient.id;

    if (!id) return;

    const { fromDate, toDate } = state.filters;
    const { items } = await paymentReminderService.getDueContractsByClient(id, fromDate, toDate);

    commit(SET_CLIENTS_DUE_CONTRACTS, items);
  },

  async getSummaryInfo({ commit, state }) {
    const {
      numberOfPastDueClients,
      numberOfDueContracts,
      numberOfRenewedContracts,
      numberOfRenewedContractsWithCash,
      numberOfRenewedContractsWithBank,
      numberOfAppointments,
      paymentReminderStatus
    } = await paymentReminderService.getSummaryInfo(state.filters);

    commit(SET_SUMMARY_INFO, {
      numberOfPastDueClients,
      numberOfDueContracts,
      numberOfRenewedContracts,
      numberOfRenewedContractsWithCash,
      numberOfRenewedContractsWithBank,
      numberOfAppointments,
      paymentReminderStatus
    });
  },

  setCurrentComponent({ commit }, component) {
    commit(SET_CURRENT_COMPONENT, component);
  },

  setLateDays({ commit }, lateDays) {
    commit(SET_LATE_DAYS, lateDays);
  }

};
